const VALID_PROTOCOLS = ['http:', 'https:'];
const HTTP_PROTOCOL = /^https?:\/\//i;

function isValidHttpUrl(value: string): boolean {
  try {
    const url = new URL(value);
    return VALID_PROTOCOLS.includes(url.protocol);
  } catch {
    return false;
  }
}

/**
 * Whether the string is a *potentially* valid URL: valid as given, or valid
 * once `https://` is prepended — so `customer.io` passes without a protocol.
 * The scheme check is start-anchored so a URL merely containing "http:" in
 * its path or query still gets prefixed.
 */
export function isPotentiallyValidUrl(value: string): boolean {
  if (value === '') {
    return false;
  }

  const candidate = HTTP_PROTOCOL.test(value) ? value : `https://${value}`;
  return isValidHttpUrl(candidate);
}
